import { render, staticRenderFns } from "./BarPagination.vue?vue&type=template&id=ff6dacc6&"
import script from "./BarPagination.vue?vue&type=script&lang=js&"
export * from "./BarPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports